import React from 'react';

const PosterIcon = () => {
  return (
    <svg width="47" height="63" viewBox="0 0 47 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.98462 10.7723H2V61.0431H45.0893V10.7723H39.7031M12.7723 10.7723H33.7185M36.7108 0V8.37847M10.3785 0V8.97693"
        stroke="#383838"
        strokeWidth="1.38826"
        strokeLinejoin="round"
      />
      <path
        d="M7.98462 10.7723H2V61.0431H45.0893V10.7723H39.7031M12.7723 10.7723H33.7185M36.7108 0V8.37847M10.3785 0V8.97693"
        stroke="#383838"
        strokeWidth="2.01197"
        strokeLinejoin="round"
      />
      <path
        d="M12.7723 8.37842H7.98462V13.1661H12.7723V8.37842Z"
        stroke="#383838"
        strokeWidth="1.38826"
        strokeLinejoin="round"
      />
      <path
        d="M39.1048 8.37842H34.3171V13.1661H39.1048V8.37842Z"
        stroke="#383838"
        strokeWidth="1.38826"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PosterIcon;
